import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Logo from '../../assets/svg/logo_dark.svg';
import './LoadingScreen.css';

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
        color: 'white',
        background: '#3AA5FD',
        height: '100vh',
        width: '100vw',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 8
    },
    container: {
        textAlign: 'center',
        position: "absolute",
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
    text: {
        marginTop: '12px',
        textTransform: 'uppercase',
        fontWeight: '700',
        fontSize: '14px',
        fontFamily: 'IntegralCF-Heavy, sans-serif',
        letterSpacing: '1px'
    }
}));

export default function About() {
    const classes = useStyles();

    return(
        <div className={classes.root}>
            <div className={classes.container}>
                <img className="loader-logo" src={Logo} alt="UP CRC"/>
            </div>
        </div>
    );
};